import type {
  CreateWorkSubmissionRequest,
  WorkSubmission,
  WorkSubmissionLinkResponse,
} from '@doneverse/shared'
import { api } from '../api/index.js'

/**
 * The doer's independent "submit your work" form (ClickUp 86d3g825y). One
 * submission per piece of work, submitted as-they-go. Workspace comes from the
 * x-doneverse-workspace-id header the api client injects.
 */
export const workSubmissionService = {
  // The acting doer's active submissions for the workspace, newest first.
  list: async (): Promise<WorkSubmission[]> => {
    const { submissions } = await api.get('/v1/work-submissions').json<{ submissions: WorkSubmission[] }>()
    return submissions
  },

  // Create one submission (the form POSTs each "Add more" block separately).
  create: async (payload: CreateWorkSubmissionRequest): Promise<WorkSubmission> => {
    const { submission } = await api
      .post(payload, '/v1/work-submissions')
      .json<{ submission: WorkSubmission }>()
    return submission
  },

  // Soft-delete one submission.
  remove: async (id: string): Promise<void> => {
    await api.delete(`/v1/work-submissions/${id}`).res()
  },

  // All links from the workspace's active submissions (any member, not just
  // the acting doer) — the Files page's separate "Submitted links" list.
  listWorkspaceLinks: async (): Promise<WorkSubmissionLinkResponse[]> => {
    const { data } = await api.get('/v1/work-submission-links').json<{ data: WorkSubmissionLinkResponse[] }>()
    return data
  },
}
